export default "__VITE_ASSET__996b8260__"